/**
 * OneSignal Storage - UX-only localStorage/sessionStorage helpers
 *
 * IMPORTANT: These values are for UX hints only, NOT for OneSignal state inference.
 * Always query Flutter/OneSignal for the true state before making
 * decisions about opt-in/opt-out operations.
 */

const PERMISSION_STORAGE_KEY = "flutter_notifications_permission"
const MODAL_DISMISSED_KEY = "notifications_permission_modal_dismissed"
const SESSION_KEY = "onesignal_device_registered_this_session"

// Key used by PushNotificationRedirectController for cold-start navigation.
// Flutter sets this value (via evaluateJavascript) during the initial page load
// when the app is launched from a tapped notification.
export const PUSH_PENDING_URL_KEY = "push_notification_pending_url"

export function getPendingPushUrl() {
    return localStorage.getItem(PUSH_PENDING_URL_KEY) || null
}

export function clearPendingPushUrl() {
    localStorage.removeItem(PUSH_PENDING_URL_KEY)
}

export const PERMISSION_STATUS = Object.freeze({
    granted: "granted",
    denied: "denied",
    unknown: "unknown"
})

export function getStoredPermission() {
    return localStorage.getItem(PERMISSION_STORAGE_KEY) || PERMISSION_STATUS.unknown
}

export function setStoredPermission(status) {
    localStorage.setItem(PERMISSION_STORAGE_KEY, status)
}

export function getDismissedData() {
    try {
        const data = localStorage.getItem(MODAL_DISMISSED_KEY)
        return data ? JSON.parse(data) : null
    } catch (_) {
        return null
    }
}

export function setDismissedData() {
    localStorage.setItem(MODAL_DISMISSED_KEY, JSON.stringify({date: new Date().toISOString()}))
}

export function clearDismissedData() {
    localStorage.removeItem(MODAL_DISMISSED_KEY)
}

export function getDenialDate() {
    return localStorage.getItem(`${PERMISSION_STORAGE_KEY}_denial_date`)
}

export function setDenialDate() {
    localStorage.setItem(`${PERMISSION_STORAGE_KEY}_denial_date`, new Date().toISOString())
}

export function clearDenialData() {
    clearDismissedData()
    localStorage.removeItem(`${PERMISSION_STORAGE_KEY}_denial_date`)
}

export function isRegisteredThisSession() {
    return sessionStorage.getItem(SESSION_KEY) === "true"
}

export function markAsRegisteredThisSession() {
    sessionStorage.setItem(SESSION_KEY, "true")
}

export function clearRegistrationFlag() {
    sessionStorage.removeItem(SESSION_KEY)
}

export function clearAllStorage() {
    localStorage.removeItem(PERMISSION_STORAGE_KEY)
    localStorage.removeItem(`${PERMISSION_STORAGE_KEY}_denial_date`)
    localStorage.removeItem(MODAL_DISMISSED_KEY)
    clearRegistrationFlag()
}
